import { createFileRoute } from "@tanstack/react-router";
import KonsollApi from "../../../../pages/KonsollApi";

export const Route = createFileRoute("/_app/account/konsoll/api")({
	component: KonsollApi,
});
